import React, { Component, useState } from 'react'
import { Styled } from './NavbarProfile.styled'

import {
  ProfileIcon,
  ArrowLeftMenu,
  ViewMenuIcon,
  LoadIcon,
  Exit,
} from 'components/Icons/Icons'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { setModalShowRedux } from 'store/modal/actions'
import { connect } from 'react-redux'
import pushDataLayerGTM from 'util/pushDataLayerGTM'

/**
 * Calcula o total de saldo considerando saldos negativos
 * Se um dos saldos for negativo, retorna apenas o saldo positivo
 * Se ambos forem positivos, retorna a soma dos dois
 * Se ambos forem negativos, retorna 0
 */
const calculateTotalBalance = (pfBalance, pjBalance) => {
  const pf = pfBalance || 0
  const pj = pjBalance || 0

  // Se um dos saldos for negativo, mostrar apenas o positivo
  if (pf < 0 && pj >= 0) {
    return pj
  }
  if (pj < 0 && pf >= 0) {
    return pf
  }
  // Se ambos forem positivos, somar
  if (pf >= 0 && pj >= 0) {
    return pf + pj
  }
  // Ambos negativos - retornar 0
  return 0
}

const NavbarProfilePrivateBar = (props) => {
  const [state, setState] = React.useState({
    infoUsuario: props.infoUsuario,
    isVisible: false,
    loadInfo: props.loadInfo,
  })

  React.useEffect(() => {
    setState({
      ...state,
      infoUsuario: props.infoUsuario,
      loadInfo: props.loadInfo,
    })
  }, [props])

  const toggleClass = () => {
    const isVisible = state.isVisible
    setState({ ...state, isVisible: !isVisible })
  }

  const sendEventGTM = (valueEvent) => {
    localStorage.removeItem('estado')
    let category = 'geral'
    let action = 'clique:header'
    let label = valueEvent
    pushDataLayerGTM(category, action, label)
  }

  return (
    <Styled.Wrap>
      <Styled.LoadInfoUser active={state.loadInfo}>
        <Styled.ModalLoad>
          <h2>Estamos carregando sua experiência</h2>
          <LoadIcon />
        </Styled.ModalLoad>
      </Styled.LoadInfoUser>
      <ul>
        <li>
          <Styled.boxUsuario>
            <span className={`profileIcon ${props.type}`}>
              <ProfileIcon />
            </span>
            <Styled.infoUsuario>
              <Styled.nomeUsuario className={`nomeUsuario ${props.type}`}>
                Olá, <span>{state.infoUsuario.firstName}</span>
              </Styled.nomeUsuario>
              <Styled.pontosUsuario className={props.type}>
                <Styled.boxPontos onClick={toggleClass}>
                  Clique para ver o saldo
                  <Styled.togglePontos>
                    <ViewMenuIcon />
                  </Styled.togglePontos>
                </Styled.boxPontos>
                <Styled.detalhePontos active={state.isVisible}>
                  {(() => {
                    const hasPF = state?.infoUsuario?.participanteFisica
                    const hasPJ = state?.infoUsuario?.participanteJuridica

                    return (
                      <>
                        {/* Saldo PF - apenas se existir participanteFisica */}
                        {hasPF && (
                          <>
                            <br />
                            <Styled.linhaPontos>
                              <span>Disponível (PF)</span>
                              <Styled.Pontos>
                                {hasPF?.avaliableBalance !== undefined
                                  ? hasPF.avaliableBalance.toLocaleString(
                                    'pt-BR'
                                  )
                                  : 0}{' '}
                                pts
                              </Styled.Pontos>
                            </Styled.linhaPontos>
                            <Styled.linhaPontos separator>
                              <span>Bloqueado (PF)</span>
                              <Styled.Pontos>
                                {hasPF?.cardLockBalance !== undefined
                                  ? hasPF.cardLockBalance.toLocaleString(
                                    'pt-BR'
                                  )
                                  : 0}{' '}
                                pts
                              </Styled.Pontos>
                            </Styled.linhaPontos>
                          </>
                        )}

                        {/* Saldo PJ - apenas se existir participanteJuridica */}
                        {hasPJ && (
                          <>
                            {hasPF && <br />}
                            <Styled.linhaPontos>
                              <span>Disponível (PJ)</span>
                              <Styled.Pontos>
                                {hasPJ?.avaliableBalance !== undefined
                                  ? hasPJ.avaliableBalance.toLocaleString(
                                    'pt-BR'
                                  )
                                  : 0}{' '}
                                pts
                              </Styled.Pontos>
                            </Styled.linhaPontos>
                            <Styled.linhaPontos separator>
                              <span>Bloqueado (PJ)</span>
                              <Styled.Pontos>
                                {hasPJ?.cardLockBalance !== undefined
                                  ? hasPJ.cardLockBalance.toLocaleString(
                                    'pt-BR'
                                  )
                                  : 0}{' '}
                                pts
                              </Styled.Pontos>
                            </Styled.linhaPontos>
                          </>
                        )}

                        {/* Total - apenas se existir ambos */}
                        {hasPF && hasPJ && (
                          <Styled.linhaPontos>
                            <span>Disponível</span>
                            <Styled.Pontos>
                              {calculateTotalBalance(
                                hasPF?.avaliableBalance,
                                hasPJ?.avaliableBalance
                              ).toLocaleString('pt-BR')}{' '}
                              pts
                            </Styled.Pontos>
                          </Styled.linhaPontos>
                        )}
                      </>
                    )
                  })()}
                </Styled.detalhePontos>
              </Styled.pontosUsuario>
            </Styled.infoUsuario>
          </Styled.boxUsuario>
        </li>
        <li>
          <Styled.Submenu className="submenu logout">
            <ul>
              <li>
                <Link to={'/logout'} onClick={() => sendEventGTM('sair')}>
                  <Exit />
                  <span>Sair</span>
                </Link>
              </li>
            </ul>
          </Styled.Submenu>

          <Styled.IcoArrow className="icoArrow">
            <ArrowLeftMenu />
          </Styled.IcoArrow>
        </li>
      </ul>
    </Styled.Wrap>
  )
}

const mapDispatch = (dispatch) =>
  bindActionCreators({ showModal: setModalShowRedux }, dispatch)

export default connect(null, mapDispatch)(NavbarProfilePrivateBar)
